export const modalOpenHandler = {
	selector: {
		modal: '.modal',
	},
	data: {
		openModalIdKey: 'openModal',
		closeModalIdKey: 'closeModal',
	},
}
